export default __webpack_public_path__ + "static/media/huevos.b0b69314.svg";